/** 既読アバター行（掲示板・マニュアル共通の最小形） */
export type ReaderRowLike = {
  staff_user_id: number;
  display_name: string;
  reader_avatar_url: string | null;
  read_at: string;
};

/**
 * 詳細取得直後の POST 既読でサーバー上の read_at は更新されるが、GET レスポンスは古いままなため、
 * ログイン職員の行を現在時刻で上書き・なければ追加し、read_at 昇順に整える。
 */
export function upsertReaderReadAtOptimistic<T extends ReaderRowLike>(
  readers: T[],
  staffUserId: number,
  readAtIso: string,
  profile: { display_name: string; avatar_url: string | null },
): T[] {
  const merged: ReaderRowLike = {
    staff_user_id: staffUserId,
    display_name: profile.display_name,
    reader_avatar_url: profile.avatar_url,
    read_at: readAtIso,
  };
  const idx = readers.findIndex((r) => r.staff_user_id === staffUserId);
  const next: T[] =
    idx >= 0
      ? readers.map((r, i) => (i === idx ? ({ ...r, ...merged } as T) : r))
      : [...readers, merged as T];
  return [...next].sort((a, b) => new Date(a.read_at).getTime() - new Date(b.read_at).getTime());
}
